import { render, staticRenderFns } from "./packageOrder.vue?vue&type=template&id=252cd544&scoped=true&"
import script from "./packageOrder.vue?vue&type=script&lang=js&"
export * from "./packageOrder.vue?vue&type=script&lang=js&"
import style0 from "./packageOrder.vue?vue&type=style&index=0&id=252cd544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cd544",
  null
  
)

export default component.exports